$(function(){
    $('.jsCollapseToggle').on('click', function(e){
        e.preventDefault();

        let target = $(this).data('target');

        $(this).parents('tr').find('td').toggleClass('border-0').find('.jsCollapseWrapper').slideToggle(500);
        $('#' + target).find('td').toggleClass('border-0').find('.jsCollapseWrapper').slideToggle(500);
    });
});